import React from "react";
import { HiX } from "react-icons/hi";

// SGEW 17 Oct: the pieces every filter and search bar is built from, so each one has the same height, border, font and a
// label above it (styles: .sgew-* in index.css). A bar lays its fields out in one row and wraps only when the row is full.
//   <FilterBar> <SearchField .../> <FilterField label="Status" kind="select"><select className="sgew-control">...
//   kind: "grow" (takes the room left - the search box), "select", "wide" (a long list, e.g. customers), "date", "auto"

export const FilterBar = ({ children, className = "" }) => <div className={`sgew-filter-bar ${className}`}>{children}</div>;

export const FilterField = ({ label, kind = "select", className = "", children }) => (
  <label className={`sgew-field sgew-${kind} ${className}`}>
    <span className="sgew-field-label">{label}</span>
    {children}
  </label>
);

export const SearchField = ({ value, onChange, label = "Search", placeholder = "Search", className = "" }) => (
  <FilterField label={label} kind="grow" className={className}>
    <span className="relative block">
      <input
        type="text"
        aria-label={label}
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="sgew-control pr-8"
      />
      {value ? (
        <HiX
          aria-label="Clear search"
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer"
          onClick={() => onChange("")}
        />
      ) : null}
    </span>
  </FilterField>
);

export const SelectField = ({ label, value, onChange, options = [], allLabel = "All", kind = "select", className = "" }) => (
  <FilterField label={label} kind={kind} className={className}>
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="sgew-control">
      {allLabel !== null && <option value="">{allLabel}</option>}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </FilterField>
);

export const DateField = ({ label, value, onChange, min, max, type = "date", className = "" }) => (
  <FilterField label={label} kind="date" className={className}>
    <input type={type} value={value || ""} min={min || undefined} max={max || undefined} onChange={(e) => onChange(e.target.value)}
      className="sgew-control" />
  </FilterField>
);

/** The right end of a bar (row count, Clear, a Fetch / Export button), lined up with the controls */
export const BarEnd = ({ children }) => <div className="sgew-bar-end">{children}</div>;

export default FilterBar;
